/**
 * 파일명: about.js
 * 작성자: 김준형
 * 작성일자: 26.08.10
 * 설명: About Us page
 */
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SEOMeta from "components/app/SEOMeta";
import Questions from "components/app/questions";
import Social from "components/landing/social";
import SectionReveal from "components/landing/sectionReveal";
import AboutVisual from "components/about/aboutVisual";
import GrowingTogether from "components/about/growingTogether";
import TomorrowStartsHere from "components/about/tomorrowStartsHere";
import CeoMessage from "components/about/ceoMessage";
import AboutHistory from "components/about/aboutHistory";
import ContactUs from "components/about/contactUs";

const findScroller = (el) => {
  let node = el.parentElement;

  while (node) {
    const overflowY = window.getComputedStyle(node).overflowY;

    if (
      (overflowY === "auto" || overflowY === "scroll") &&
      node.scrollHeight > node.clientHeight
    ) {
      return node;
    }

    node = node.parentElement;
  }

  return document.scrollingElement;
};

function About() {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return undefined;

    const target = document.getElementById(location.hash.slice(1));
    if (!target) return undefined;

    const goto = () => {
      const scroller = findScroller(target);
      const header = document.getElementById("page_header");
      const headerHeight = header ? header.getBoundingClientRect().height : 0;

      const top =
        target.getBoundingClientRect().top -
        scroller.getBoundingClientRect().top +
        scroller.scrollTop -
        headerHeight;

      scroller.scrollTo({ top, behavior: "auto" });
    };

    const timers = [50, 400, 1100].map((delay) => setTimeout(goto, delay));

    return () => timers.forEach(clearTimeout);
  }, [location.hash, location.pathname]);

  return (
    <>
      <SEOMeta
        title="About Us, 리브테크놀로지"
        description="리브테크놀로지의 기업 소개와 CEO 인사말, 기업 연혁 및 솔루션 연혁을 소개합니다."
        keywords="리브테크놀로지, 리브테크, riv, riv Technology, 회사소개, About Us, CEO 인사말, 기업 연혁, 솔루션 연혁, 스마트워크, 화상회의, 원격진료"
      />

      <SectionReveal defaultOn>
        <AboutVisual />
      </SectionReveal>
      <SectionReveal>
        <GrowingTogether />
      </SectionReveal>
      <SectionReveal>
        <TomorrowStartsHere />
      </SectionReveal>
      <SectionReveal>
        <CeoMessage />
      </SectionReveal>
      <AboutHistory />
      <SectionReveal>
        <ContactUs />
      </SectionReveal>
      <SectionReveal>
        <Social />
      </SectionReveal>
      <SectionReveal>
        <Questions />
      </SectionReveal>
    </>
  );
}

export default About;
